(function () {
  "use strict";

  function initialiseWindsorPicker(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-af-windsor-colour-picker]").forEach(function (picker) {
      if (picker.dataset.afWindsorReady === "true") return;
      var grid = picker.querySelector("[data-af-windsor-colour-grid]");
      var toggle = picker.querySelector("[data-af-windsor-colour-toggle]");
      if (!grid || !toggle) return;

      picker.dataset.afWindsorReady = "true";
      var nodes = Array.prototype.slice.call(grid.querySelectorAll(".m-product-option--node"));
      var selectedIndex = nodes.findIndex(function (node) {
        var input = node.querySelector("input[type='radio']");
        return Boolean(input && input.checked);
      });

      function setExpanded(expanded) {
        grid.classList.toggle("is-expanded", expanded);
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
        toggle.textContent = expanded ? toggle.dataset.expandedLabel : toggle.dataset.collapsedLabel;
      }

      setExpanded(selectedIndex >= 10);
      toggle.addEventListener("click", function () {
        setExpanded(toggle.getAttribute("aria-expanded") !== "true");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initialiseWindsorPicker(document); });
  } else {
    initialiseWindsorPicker(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    initialiseWindsorPicker(event.target);
  });
})();
